import React from "react";
import logo from "..//assets/logo.png";
import { useState } from "react";
import { CiUser } from "react-icons/ci";
import icon from "..//assets/icon.png";
import icon1 from "..//assets/icon1.png";
import icon2 from "..//assets/icon2.png";
import icon3 from "..//assets/icon3.png";
import face from "..//assets/face.png";
import { HiMenu, HiX } from "react-icons/hi";
import twit from "..//assets/video.png";
import insta from "..//assets/insta.png";
import blogImage1 from "..//assets/blog1.png"; // Example blog images
import blogImage2 from "..//assets/blog2.png";
import blogImage3 from "..//assets/blog3.png";
import bd1 from "..//assets/blog_banner.jpg";
import bd2 from "..//assets/bd2.png";
import bd3 from "..//assets/bd3.png";
import returnIcon from "../assets/icons/arrow-right-left.svg";
import shippingIcon from "../assets/icons/la--shipping-fast.svg";

// import bannerImage from './assets/banner.jpg';  // Logo image path
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Blog() {
    return (
        <>
            <Header />
            <BlogSection />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function BlogSection() {
    // const blogs = [
    //     {
    //         id: 1,
    //         image: bd1,
    //         heading: "How to use Bestie Products?",
    //         subheading:
    //             "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More...",
    //     },
    //     // {
    //     //     id: 2,
    //     //     image: bd2,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading:
    //     //         "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More...",
    //     // },
    //     // {
    //     //     id: 3,
    //     //     image: bd3,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading:
    //     //         "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More...",
    //     // },

    //     //  {
    //     //     id: 1,
    //     //     image: blogImage1,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     // },
    //     // {
    //     //     id: 2,
    //     //     image: blogImage2,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     //    },
    //     // {
    //     //     id: 3,
    //     //     image: blogImage3,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     //  },
    //     //  {
    //     //     id: 1,
    //     //     image: blogImage1,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     // },
    //     // {
    //     //     id: 2,
    //     //     image: blogImage2,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     //    },
    //     // {
    //     //     id: 3,
    //     //     image: blogImage3,
    //     //     heading: "How to use Bestie Products?",
    //     //     subheading: "Gym clothes should fit snugly but not restrictively. For tops, choose a fit that doesn't chafe or shift during movement. For bottoms Read More..."
    //     //  },
    // ];

    return (
        <div className="container px-4 mx-auto mt-10">
            <div className="flex items-center space-x-2 text-sm text-gray-500">
                <a
                    href="/"
                    className="font-sans text-lg font-medium hover:text-gray-700"
                >
                    Home
                </a>
                <span className="text-gray-400">›</span>
                <a
                    href="/blog"
                    className="font-sans text-lg font-medium hover:text-black"
                >
                    Blogs
                </a>
            </div>
            <div className="flex flex-col items-center justify-center gap-4">
                <h3 className="text-xl font-semibold">
                    Caring Conversations: Tips, Guides & Wellness from Bestie
                </h3>
                <p className="text-lg">
                    Welcome to the Bestie Blog – your go-to resource for all
                    things comfort, care, and cleanliness. Whether you're a{" "}
                    <br />
                    parent, a caregiver, or simply looking for better hygiene
                    solutions, we’re here to help you navigate daily life with
                    <br />
                    confidence and care.
                </p>
            </div>
            <div className="grid grid-cols-1 gap-4 mt-10 mb-5 ">
                <div className="mb-10 overflow-hidden bg-white rounded-lg shadow-md">
                    <img
                        src={bd1}
                        alt={"blog"}
                        className=" object-cover w-full  "
                    />
                    <div className="p-4 py-5">
                        <h3 className="py-2 font-sans text-xl font-semibold">
                            Diaper Duty Simplified: A Parent’s Guide to Choosing
                            the Best Baby Diapers
                        </h3>
                        <p className="font-sans text-lg font-normal text-black">
                            From leaks to rashes, new parents face it all.
                            Discover what makes Bestie Baby Diapers gentle on
                            delicate skin, and how to choose the right fit and
                            absorbency level for your little bundle of joy.
                        </p>
                    </div>
                    <div className="p-4 py-5">
                        <h3 className="py-2 font-sans text-xl font-semibold">
                            Confidence at Any Age: Why Bestie Adult Diapers
                            Offer More Than Just Protection
                        </h3>
                        <p className="font-sans text-lg font-normal text-black">
                            Managing incontinence shouldn’t mean compromising
                            dignity. Explore how Bestie Adult Diapers combine
                            comfort, discretion, and advanced leak-lock
                            technology to support freedom and peace of mind.
                        </p>
                    </div>
                    <div className="p-4 py-5">
                        <h3 className="py-2 font-sans text-xl font-semibold">
                            Period Care 101: What Makes a Sanitary Napkin Truly
                            Comfortable?
                        </h3>
                        <p className="font-sans text-lg font-normal text-black">
                            Your period shouldn't interrupt your power. Learn
                            why Bestie Sanitary Napkins are designed for active
                            days and restful nights—with breathable materials,
                            maximum absorbency, and rash-free protection.
                        </p>
                    </div>
                    <div className="p-4 py-5">
                        <h3 className="py-2 font-sans text-xl font-semibold">
                            The Power of a Wipe: How Wet Wipes Can Change Your
                            Hygiene Routine
                        </h3>
                        <p className="font-sans text-lg font-normal text-black">
                            Not just for babies! From messy hands to on-the-go
                            freshening, Bestie Wet Wipes are gentle, multi-use,
                            and always there when you need them. Discover new
                            uses and why they belong in every bag.
                        </p>
                    </div>
                </div>
            </div>
            {/* <div className="mb-8">
                <p className="my-2 font-sans text-lg font-normal text-gray-600">
                    <span className="font-semibold"> 1. Essential Care:</span> A
                    Guide to Baby Products, Sanitary Pads, and Adult Diapers
                </p>
                <p className="my-2 font-sans text-lg font-normal text-gray-600">
                    <span className="font-semibold">
                        2. From Newborns to Adults:{" "}
                    </span>{" "}
                    Finding Comfort with Baby Products, Sanitary Pads, and
                    Diapers
                </p>
                <p className="my-2 font-sans text-lg font-normal text-gray-600">
                    <span className="font-semibold">
                        3. All You Need for Comfort:
                    </span>{" "}
                    Exploring Baby Products, Sanitary Pads, and Adult Diapers
                </p>
            </div> */}
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping all over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Blog;
